<template>
    <!-- footer -->
    <div id="footer">
        <div class="footer-info">
            <a href="/"> <div class="logo-text">Razum<span class="logo-text-pink">V</span>Dom</div>
            </a>
            <br class="clear">
        </div>
        <!-- <div class="footer-subscribe">
            <div class="footer-subscribe-row">
                <form action="/local/components/multisite/subscribe.email/ajax.php" class="footer-subscribe-form" id="subscribe-form">
                    <input type="hidden" name="XHR" value="YES">
                    <input type="hidden" name="ACTION" value="subscribe">
                    <input class="footer-subscribe__input" type="email" placeholder="Подписаться на новости" name="email" value="" id="subscribe_email">
                    <div class="footer-subscribe__submit-box">
                        <input class="footer-subscribe__submit" type="submit" value=" " id="subscribe_button">
                    </div>
                    <div class="footer-subscribe__error-email">E-mail заполнен некорректно</div>
                    <div class="footer-subscribe__error-signed">Этот адрес уже подписан на рассылку</div>
                </form>
                <div class="footer-subscribe-descr">Подписываясь на&nbsp;рассылку, вы&nbsp;соглашаетесь
                    <br>с&nbsp;<a href="/oferta/" rel="nofollow">условиями оферты</a> и <a href="/oferta/politika/" rel="nofollow">политикой
                        конфиденциальности</a></div>
                <div class="footer-subscribe-success">Есть! Теперь вы&nbsp;подписаны на&nbsp;рассылку</div>
            </div>
        </div> -->
        <div class="footer-menu">
            <div class="footer-menu-cont">
                <div class="footer-menu-column">
                    <div class="footer-chat">
                        <a class="footer-chat-item footer-chat__whatsapp" href="https://api.whatsapp.com/send?phone=" target="_blank" title="Связаться с нами в WhatsApp" rel="nofollow"></a>
                        <a class="footer-chat-item footer-chat__telegram" href="tg://resolve?domain=" target="_blank" title="Связаться с нами в Telegram" rel="nofollow"></a>
                    </div>
                    <div class="footer-phone">
                        <a href="tel:89959970558">8-995-997-05-58</a>
                        <span>c 9:00 до 22:00, без выходных</span>
                    </div>
                    <!-- <div class="footer-social">
                        <a href="https://www.facebook.com/" class="footer-social-item footer-social-item__fb" title="Facebook" target="_blank" rel="nofollow"></a>
                        <a href="https://vk.com/" class="footer-social-item footer-social-item__vk" title="Вконтакте" target="_blank" rel="nofollow"></a>
                        <a href="https://instagram.com/" class="footer-social-item footer-social-item__inst" title="Instagram" target="_blank" rel="nofollow"></a>
                        <a href="https://www.youtube.com/user/" class="footer-social-item footer-social-item__youtube" title="YouTube" target="_blank" rel="nofollow"></a>
                    </div> -->
                </div>
                <!--<div class="footer-menu-column">
                    <a href="/about/" class="footer-main-a footer-menu-title ">О компании</a>
                    <a href="/shops/all/" class="footer-main-a  ">Адреса магазинов</a>
                    <a href="/benefits/" class="footer-main-a  " rel="nofollow">Преимущества</a>
                    <a href="/allnews/" class="footer-main-a  ">Акции и новости</a>
                    <a href="/services/" class="footer-main-a  ">Услуги</a>
                    <a href="/academy/" class="footer-main-a  ">Академия</a>
                    <a href="/blog/" target="_blank" class="footer-main-a  ">Блог</a>
                    <a href="/b2b/" class="footer-main-a  ">Корпоративным клиентам</a>
                    <a href="/vacancies/" class="footer-main-a  " rel="nofollow">Вакансии</a>
                    <a href="/contacts/" class="footer-main-a  ">Контакты</a>
                    <a href="/feedback/" class="footer-main-a  ">Обратная связь</a>
                </div>
                <div class="footer-menu-column">
                    <span class="footer-main-a footer-menu-title">Помощь</span>
                    <a href="/deliveryandpayment/" class="footer-main-a  ">Доставка и оплата</a>
                    <a href="/return/" class="footer-main-a  ">Обмен и возврат</a>
                    <a href="/service/" class="footer-main-a  ">Гарантии</a>
                    <a href="/promo/trade-in/" class="footer-main-a  ">Trade-in</a>
                    <a href="/care/" class="footer-main-a  ">Сервисные центры Apple</a>
                    <a href="/service-program/" class="footer-main-a  ">Сервисная программа</a>
                    <a href="/promo/bonuses/" class="footer-main-a  " rel="nofollow">Бонусная программа</a>
                    <a href="/promo/gift-cards/" class="footer-main-a  " rel="nofollow">Подарочные карты</a>
                    <a href="/promo/financing/" class="footer-main-a  ">Рассрочка и кредит</a>
                    <a href="https://razumvdom.ru" class="footer-main-a  ">Мобильная версия сайта</a>
                </div>
                <div class="footer-menu-column">
                    <a href="/apple-products/" class="footer-main-a footer-menu-title">Каталог</a>
                    <a href="/apple-mac/" class="footer-main-a half-a ">Mac</a>
                    <a href="/apple-iphone/" class="footer-main-a half-a ">iPhone</a>
                    <a href="/apple-watch/" class="footer-main-a half-a ">Watch</a>
                    <a href="/apple-ipad/" class="footer-main-a half-a ">iPad</a>
                    <a href="/accessories/" class="footer-main-a half-a ">Аксессуары</a>
                    <a href="/gadgets/" class="footer-main-a half-a ">Гаджеты</a>
                    <a href="/sale/" class="footer-main-a half-a ">Распродажа</a>
                </div> -->
            </div>
        </div>
        <div class="footer-bottom">
            <div class="footer-coryright">
                © 2019-{{ new Date().getFullYear() }} RazumVDom
            </div>
            <!-- <div class="footer-links">
                <a href="/oferta/politika/" rel="nofollow">Политика конфиденциальности</a>
                <a href="/oferta/" rel="nofollow">Оферта</a>
            </div> -->
            <!-- <span class="footer-akit" href="/akit/">Участник</span> -->
        </div>
    </div>
    <!-- /footer -->
</template>
<script>
export default {}
</script>
<style>
/*FOOTER*/

#footer {
  width: 100%;
  background-color: #f7f7f7;
  font-family: 'Graphik-Regular-Cy';
  min-width: 1100px;
}

.footer-info {
  width: 1100px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 40px 0 78px 270px;
  border-bottom: 1px solid #f4f4f4;
  position: relative
}

.footer-info h5 {
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #222;
  font-weight: Normal;
  font-family: 'Graphik-Regular-Cy';
}

.footer-info > span {
  position: absolute;
  left: 0px;
  top: 20px;
}

.footer-info > a {
  position: absolute;
  left: 0px;
  top: 20px;
}

.footer-info-column {
  width: 270px;
  float: left;
  position: relative;
}

.footer-info-column p {
  padding: 5px 0;
  width: 230px;
  margin: 0;
  font-size: 13px;
  line-height: 21px;
  color: #222;
}

#footer .half-a {
  width: 50%;
  float: left;
}

.footer-menu {
  border-top: 1px solid #e6e6e6;
  padding-top: 50px;
}

.footer-menu-cont {
  position: relative;
  width: 1100px;
  margin: 0 auto;
  overflow: hidden;
}

.footer-menu-left {
  width: 270px;
  float: left;
  box-sizing: border-box;
  padding-right: 50px;
}

.footer-menu-left img {
  display: block;
  margin-bottom: 15px;
}

.footer-menu-column {
  width: 275px;
  float: left;
}

.footer-main-a {
  width: 100%;
  color: #666;
  font-size: 13px;
  font-family: 'Graphik-Regular-Cy';
  line-height: 13px;
  margin-bottom: 15px;
  display: block;
}

.footer-main-a:hover {
  color: #de3381;
}

.footer-main-a.active {
  color: #de3381;
}

.footer-menu-title {
  font-weight: bold;
  line-height: 17px !important;
  color: #666;
}

span.footer-menu-title:hover {
  color: #666;
}

/*  FOOTER SOCIAL BUTTON */
.footer-socialgroup {
  width: 320px;
  margin: 0 auto;
  overflow: hidden;
}

.footer-social {
  overflow: hidden;
  margin-top: 30px;
}

.lectures-slider__content .footer-social img {
  height: 100%;
}

.footer-social-a {
  margin-right: 13px;
}

.footer-social-item {
  display: block;
  float: left;
  width: 29px;
  height: 29px;
  margin-left: 15px;
}

.footer-social-item:first-child {
  margin-left: 0;
}

.footer-social-item__fb {
  background: url('../assets/images/social/facebook.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__fb:hover {
  background: url('../assets/images/social/facebook-hover.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__fb:active {
  background: url('../assets/images/social/facebook-pressed.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__tw {
  background: url('../assets/images/social/twitter.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__tw:hover {
  background: url('../assets/images/social/twitter-hover.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__tw:active {
  background: url('../assets/images/social/twitter-pressed.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__vk {
  background: url('../assets/images/social/vk.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__vk:hover {
  background: url('../assets/images/social/vk-hover.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__vk:active {
  background: url('../assets/images/social/vk-pressed.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__inst {
  background: url('../assets/images/social/instagram.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__inst:hover {
  background: url('../assets/images/social/instagram-hover.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__inst:active {
  background: url('../assets/images/social/instagram-pressed.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__youtube {
  background: url('../assets/images/social/youtube.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__youtube:hover {
  background: url('../assets/images/social/youtube-hover.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

.footer-social-item__youtube:active {
  background: url('../assets/images/social/youtube-pressed.svg') left top no-repeat transparent;
  background-size: 100% auto;
}

/* FOOTER CHAT ICON */
.footer-chat {
  overflow: hidden;
}

.footer-chat-item {
  display: block;
  float: left;
  width: 29px;
  height: 29px;
  margin-left: 15px;
}

.footer-chat-item:first-child {
  margin-left: 0;
}

.footer-chat__whatsapp {
  background: transparent url('../assets/images/messenger/whatsapp-color.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

.footer-chat__whatsapp:hover {
  background: transparent url('../assets/images/messenger/whatsapp-color-hover.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

.footer-chat__whatsapp:active {
  background: transparent url('../assets/images/messenger/whatsapp-pressed.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

.footer-chat__viber {
  background: transparent url('../assets/images/messenger/viber-color.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

.footer-chat__viber:hover {
  background: transparent url('../assets/images/messenger/viber-color-hover.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

.footer-chat__viber:active {
  background: transparent url('../assets/images/messenger/viber-pressed.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

.footer-chat__telegram {
  background: transparent url('../assets/images/messenger/telegram-color.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

.footer-chat__telegram:hover {
  background: transparent url('../assets/images/messenger/telegram-color-hover.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

.footer-chat__telegram:active {
  background: transparent url('../assets/images/messenger/telegram-pressed.svg') 0 0 no-repeat;
  background-size: 100% auto;
}

/* FOOTER SUBSCRIBE */
.footer-subscribe {
  height: 110px;
  border-top: 1px solid #e6e6e6;
}

.footer-subscribe-row {
  width: 1100px;
  margin: 0 auto;
  padding: 40px 0 40px 270px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.footer-subscribe-form {
  float: left;
  width: 240px;
  margin-right: 40px;
  position: relative;
  z-index: 1;
  opacity: 1;
  -webkit-transition: .25s;
  transition: .25s;
}

.footer-subscribe-form.no-active {
  opacity: 0;
}

.footer-subscribe__input {
  width: 240px;
  height: 30px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  padding: 0 30px 0 10px;
  box-sizing: border-box;
  border-radius: 3px;
  font-size: 13px;
}

.footer-subscribe input[type="text"]:focus {
  border: 1px solid #999 !important;
}

.footer-subscribe .input-error {
  border: 1px solid #78b301 !important;
}

.footer-subscribe__submit {
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  position: relative;
  z-index: 1;
}

.footer-subscribe__submit-box {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0;
  right: 0;
}

.footer-subscribe__submit-box:before {
  display: block;
  width: 13px;
  height: 14px;
  content: ' ';
  background: transparent url('../assets/images/icons-subscribe.svg') 0 0 no-repeat;
  background-size: 54px 14px;
  position: absolute;
  right: 10px;
  top: 8px;
}

.footer-subscribe__submit-box:hover:before {
  display: block;
  width: 13px;
  height: 14px;
  content: ' ';
  background: transparent url('../assets/images/icons-subscribe.svg') -13px 0 no-repeat;
  background-size: 54px 14px;
  position: absolute;
  right: 10px;
  top: 8px;
}

.footer-subscribe__submit-box:active:before {
  display: block;
  width: 13px;
  height: 14px;
  content: ' ';
  background: transparent url('../assets/images/icons-subscribe.svg') -26px 0 no-repeat;
  background-size: 54px 14px;
  position: absolute;
  right: 10px;
  top: 8px;
}

.footer-subscribe-descr {
  float: left;
  font-size: 11px;
  line-height: 13px;
  color: #999;
  margin-top: 2px;
  position: relative;
  z-index: 1;
  opacity: 1;
  -webkit-transition: .25s;
  transition: .25s;
}

.footer-subscribe-descr a {
  color: #666;
}

.footer-subscribe-descr.no-active {
  opacity: 0;
}

.footer-subscribe__error-signed, .footer-subscribe__error-email {
  width: 400px;
  font-size: 13px;
  color: #78b301;
  margin: 5px 0 0;
  position: absolute;
  opacity: 0;
  -webkit-transition: .25s;
  transition: .25s;
}

.footer-subscribe__error-signed.active, .footer-subscribe__error-email.active {
  opacity: 1;
}

.footer-subscribe-success {
  height: 32px;
  font-size: 13px;
  line-height: 32px;
  position: relative;
  padding-left: 30px;
  position: absolute;
  opacity: 0;
  -webkit-transition: .25s .25s;
  transition: .25s .25s;
}

.footer-subscribe-success:before {
  display: block;
  width: 15px;
  height: 14px;
  content: ' ';
  background: transparent url('../assets/images/icons-subscribe.svg') -39px 0 no-repeat;
  background-size: 54px 14px;
  position: absolute;
  left: 0;
  top: 8px;
}

.footer-subscribe-success.active {
  opacity: 1;
}

.footer-email-a {
  background: url('../assets/images/footer-email.png') left center no-repeat transparent;
  background-size: 19px auto;
  padding-left: 30px;
}

.footer-email-a:hover {
  color: #de3381;
  background: url('../assets/images/footer-email-hov.png') left center no-repeat transparent;
  background-size: 19px auto;
  padding-left: 30px;
}

.footer-adress-a {
  background: url('../assets/images/footer-address.png') 1px center no-repeat transparent;
  background-size: 19px auto;
  background-size: auto 17px;
  padding-left: 30px;
  height: 20px;
  line-height: 20px;
}

.footer-adress-a:hover {
  color: #de3381;
  background: url('../assets/images/footer-address-hov.png') 1px center no-repeat transparent;
  background-size: 19px auto;
  background-size: auto 17px;
  padding-left: 30px;
  height: 20px;
  line-height: 20px;
}

.footer-contacts-a {
  background: url('../assets/images/footer-contacts.png') 2px center no-repeat transparent;
  background-size: 19px auto;
  padding-left: 30px;
  height: 20px;
  line-height: 20px;
}

.footer-contacts-a:hover {
  color: #de3381;
  background: url('../assets/images/footer-contacts-hov.png') 2px center no-repeat transparent;
  background-size: 19px auto;
  padding-left: 30px;
  height: 20px;
  line-height: 20px;
}

.footer-main-job-a {
  background: url('../assets/images/footer-job.png') 1px center no-repeat transparent;
  background-size: 19px auto;
  padding-left: 30px;
}

.footer-main-job-a:hover {
  color: #de3381;
  background: url('../assets/images/footer-job-hov.png') 1px center no-repeat transparent;
  background-size: 19px auto;
  padding-left: 30px;
}

.footer-phone {
  width: 205px;
  margin-top: 18px;
  border-bottom: 1px solid #e6e6e6;
  font-size: 18px;
  color: #666;
  line-height: 18px;
  padding-bottom: 24px;
}

.footer-messenger {
  line-height: 18px;
  background: url('../assets/images/footer-messenger.jpg') left top no-repeat transparent;
  padding-left: 30px;
  font-size: 18px;
  color: #666;
  margin-top: 20px;
}

.footer-phone span, .footer-messenger span {
  color: #666;
  font-size: 13px;
  display: block;
  margin-top: 9px;
}

.footer-phone:hover a {
  color: #de3381;
}

.footer-phone a {
  color: #666;
}

.footer-messenger {
  background-image: url('../assets/images/footer-messanger.png');
  background-size: 16px;
}

.footer-messenger:after {
  content: '';
  position: absolute;
  opacity: 0;
  display: block;
  background-image: url('../assets/images/footer-messanger-hover.png');
}

.footer-messenger:hover {
  background-image: url('../assets/images/footer-messanger-hover.png');
}

.footer-messenger:hover a {
  color: #de3381;
}

.footer-messenger a {
  color: #666;
}

.footer-bottom {
  overflow: hidden;
  width: 1100px;
  margin: 0 auto;
  position: relative;
}

.footer-coryright {
  float: left;
  margin: 0 auto;
  font-size: 13px;
  color: #222;
  padding: 30px 0;
}

#footer-small {
  margin-top: -77px;
}

#footer-small .footer-coryright {
  width: 1100px;
  float: none;
}

.footer-akit {
  display: block;
  height: 42px;
  float: right;
  font-size: 13px;
  line-height: 42px;
  color: #666;
  background: transparent url('../assets/images/akit.png') center right no-repeat;
  background-size: 40px auto;
  padding-right: 56px;
  margin-top: 17px;
}

.footer-links {
  float: left;
  padding: 30px 0;
  font-size: 13px;
}

.footer-links a {
  color: #666;
  margin-left: 30px;
}

.footer-links a:hover {
  color: #de3381;
}

.footer-catalogue {
  width: 1100px;
  margin: 0 auto;
  padding: 40px 0;
  border-bottom: 1px solid #f4f4f4;
}

.footer-catalogue-column {
  width: 270px;
  float: left;
}

.footer-catalogue-cat {
  margin-bottom: 15px;
}

.footer-catalogue-cat span {
  font-size: 18px;
  line-height: 34px;
  color: #222;
  display: block;
  margin-bottom: 5px;
}

.shadow {
  display: none;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 601;
}

.shadow2 {
  display: none;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 399;
  top: 0;
}

.footer-info-3-column {
  width: 830px;
  font-size: 13px;
  line-height: 21px;
  color: #222;
  -webkit-columns: 3;
  -moz-columns: 3;
  columns: 3;
  -webkit-column-gap: 40px;
  -moz-column-gap: 40px;
  column-gap: 40px;
  margin: 5px 0;
  column-width: 230px;
  -webkit-column-width: 230px;
  -moz-column-width: 230px;
}

.footer-info-3-column p {
  margin: 0;
}
.header-logo {
    display: block;
    margin: 23.5px 30px 23.5px 0;
    float: left;
    padding: 0;
    border: 0;
}
.content__col_main {
  padding-bottom: 50px;
}
@media screen and (max-width: 767px) {
  footer {
    width: 100vw;
  } 
}
</style>